module.exports = __webpack_public_path__ + "static/media/Image-Hero.b267a40e.jpeg";